// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.render:hover{
  animation:  zoom-in 5s ease-out both;
  overflow: hidden;
  cursor: pointer;
}


@keyframes zoom-in {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1.5, 1.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Renders/style.css"],"names":[],"mappings":"AAAA;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".render:hover{\n  -webkit-animation: zoom-in 5s ease-out both;\n  animation:  zoom-in 5s ease-out both;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n\n@keyframes zoom-in {\n  0% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1.2, 1.2);\n  }\n  100% {\n    transform: scale(1.5, 1.5);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
